export const EVENT_NAME_TRACKING_SAVE_ITEMS = {
  relatedAd: 'WatchlistAddRelatedAd',
  regular: 'WatchlistAdd',
};

export const FAVORITE_SRP_EVENT_SOURCE = 'FavoriteSRP';
